import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const AccountCategoryBasicInfoComponent = ({
    selectAccountCategories, handleInnerFormChange, accountHeadsList, accountCategoriesList,
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Account Head"
                            labelField="Text"
                            list={accountHeadsList}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'AccountHeadId'
                                )
                            }}
                            optionName='Choose Account Head'
                            type="select"
                            value={selectAccountCategories?.AccountHeadId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Category Name"
                            labelField="CategoryName"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'CategoryName'
                                );
                            }}
                            type="text"
                            value={selectAccountCategories?.CategoryName}
                        />
                        <InputContainer
                            label="Description"
                            labelField="Description"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Description'
                                );
                            }}
                            type="text"
                            value={selectAccountCategories?.Description}
                        />
                        <InputContainer
                            label="Display Order"
                            labelField="DisplayOrder"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'DisplayOrder'
                                );
                            }}
                            type="number"
                            value={selectAccountCategories?.DisplayOrder}
                        />
                        <InputContainer
                            label="Sub Category"
                            name="IsSubCategory"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsSubCategory'
                                )
                            }}
                            type="checkbox"
                            value={selectAccountCategories?.IsSubCategory}
                        />
                        {selectAccountCategories?.IsSubCategory && (
                            <InputContainer
                                label="Parent Account Category"
                                labelField="CategoryName"
                                list={accountCategoriesList}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'ParentAccountCategoryId'
                                    );
                                }}
                                optionName='Choose Parent Account Category'
                                type="select"
                                value={selectAccountCategories?.ParentAccountCategoryId}
                                valueField="Id"
                            />
                        )}
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}
export default AccountCategoryBasicInfoComponent;
